// Mirrored from mju-ai-workbench/shared/schemas/foundry.ts at origin/feat/d273-foundry-ab (cd68dbc7) — keep the two identical but for this line.
/**
 * The `foundry` clause of `.mojoup/policy.json` (roadmap D273, docs/plans/2026-10-foundry-agents-workbench.md
 * section 7): whether team members may run as Microsoft Foundry agents, in which Foundry projects, on which
 * model deployments, with which of Foundry's own tools, under whose identity, on nodes or not, and on which
 * of Foundry's API surfaces. Enforced by the workbench (src/foundry/foundryGate.ts); an organisation's
 * console renders it from the policy manifest like any other clause, whose field descriptions live in
 * src/platform/policyManifest.ts (`FIELD_DESCRIPTIONS`), so this file can be copied as it is.
 *
 *  - `allowed`: left out of a managed policy (an organisation's), no Foundry members; a repository's own
 *    file allows them unless it says false.
 *  - `projects`: the Foundry projects members may use, each with its model deployments (an explicit list,
 *    never "any"; left out, none) and the Foundry-side tools members may have attached (left out, none).
 *  - `identity`: `person` (the default) — every call goes as the person the member works for, with their own
 *    Foundry sign-in; `organisation` — the organisation's own identity (client credentials kept as an
 *    organisation secret) may be used, only for unattended work (routines, nodes).
 *  - `nodes`: whether a node may run a Foundry member for a person who released their Foundry sign-in to it.
 *  - `apiVersions`: the Foundry surfaces the organisation accepts; left out, whatever the workbench knows.
 *
 * Plain zod, no Node.
 */
import { z } from "zod";
export const FOUNDRY_IDENTITIES = ["person", "organisation"];
export const foundryProjectPolicySchema = z.object({
    endpoint: z.string().min(1).max(500),
    deployments: z.array(z.string().min(1).max(200)).max(100).optional(),
    hostedTools: z.array(z.string().min(1).max(100)).max(50).optional(),
});
export const foundryPolicySchema = z.object({
    allowed: z.boolean().optional(),
    projects: z.array(foundryProjectPolicySchema).max(100).optional(),
    identity: z.enum(FOUNDRY_IDENTITIES).optional(),
    nodes: z.boolean().optional(),
    apiVersions: z.array(z.string().min(1).max(40)).max(20).optional(),
});
//# sourceMappingURL=foundry.js.map